import React from 'react';
import Select from 'react-select';

class InboxQueryBranchesSelected extends React.Component {
  render() {
    // Create a merged options array that includes both current employer branches
    // and any previously selected branches from other employers
    const mergedOptions = [...this.props.queryBranches];

    // Add any selected branches that aren't already in the queryBranches list
    this.props.selectedBranches.forEach(selectedBranch => {
      // Check if this selected branch is already in the queryBranches list
      const existsInQueryBranches = mergedOptions.some(
        branch => branch.id === selectedBranch.id
      );

      // If it's not in the current employer's branches, add it to options
      if (!existsInQueryBranches) {
        mergedOptions.push(selectedBranch);
      }
    });

    // Map the merged options array to the format required by react-select
    const selectOptions = mergedOptions.map(branch => ({
      label: branch.name,
      value: branch.id,
    }));

    return (
      <Select
        isMulti
        name="query_branches"
        isSearchable
        isDisabled={this.props.isDisabled}
        onChange={(query_branches) => {
          let selected = [];
          if (query_branches != null) {
            // Find the complete branch objects for the selected IDs
            selected = mergedOptions.filter((branch) =>
              query_branches.map((option) => option.value).includes(branch.id)
            );
          }
          this.props.updatedBranchReceiveQueries(selected);
        }}
        value={this.props.selectedBranches.map((branch) => ({
          label: branch.name,
          value: branch.id,
        }))}
        options={selectOptions}
      />
    );
  }
}

export default InboxQueryBranchesSelected;
